import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import {useLocation} from 'react-router-dom'

import * as pdpSelectors from '../../../store/productDetailPage'
import * as reviewsActions from '../../../actions/reviews'
import * as trackReviews from '../../../track/reviews'

import Mobile from '../../Mobile'

const urlToHttps = (url) => url.replace(/^http:\/\//i, 'https://')

const ProductReviewThumbnail = ({image, productName, openReviewImageModal}) => {
  const {pathname} = useLocation()

  const handleClick = () => {
    trackReviews.reviewImageModalOpened({
      product: productName,
      location: pathname.includes('reviews') ? 'All Reviews' : 'Featured Reviews',
    })
    openReviewImageModal(urlToHttps(image.originalUrl))
  }

  return (
    <div className="product-review-thumbnail">
      <button onClick={handleClick} type="button">
        <span className="u-sr-only">View customer photo</span>
        <img alt="" src={urlToHttps(image.thumbUrl)} />
        <Mobile>
          <p>View Customer Photo</p>
        </Mobile>
      </button>
    </div>
  )
}

ProductReviewThumbnail.propTypes = {
  image: PropTypes.shape({
    thumbUrl: PropTypes.string.isRequired,
    originalUrl: PropTypes.string.isRequired,
  }),
  productName: PropTypes.string.isRequired,
  openReviewImageModal: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  productName: pdpSelectors.productName,
})

const mapDispatchToProps = {
  openReviewImageModal: reviewsActions.openReviewImageModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductReviewThumbnail)
